import React from 'react';
import { Router } from '@reach/router';
import Layout from '../../components/layout';
import TeamWrapper from '../../components/about/TeamWrapper';

const Leadership = ({ location }) => {
  const headerText =
    location.pathname === '/about/' || '/about' ? 'ABOUT iDECIDE' : null;

  return (
    <Layout headerText={headerText} heroFont="has-text-white" heroBg="fields">
      <Router>
        <TeamWrapper path="/about/leadership" />
      </Router>
    </Layout>
  );
};

export default Leadership;
